export const checkBrowsers = {
  isChrome:
    /Google Inc/.test(navigator.vendor) && /Chrome/.test(navigator.userAgent),
  isIphoneChrome:
    /Apple/.test(navigator.vendor) && /CriOS/.test(navigator.userAgent),
};

export const isAvailableBrowser = Object.values(checkBrowsers).some(
  match => match
);
